import { getGlobalState } from './globalState'

export runtime(method) ->
  st = getGlobalState()
  st.imports.runtime(method)
